/// <reference types="node" />
export var CLIENT_VERSION = "4.26.5";